const initCatalog = {
  catalogs: [],
  catalogDetail: {},
  catalogCategories: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterTenantPage: "",
  isFormLoading: false,
  isCatalogDetailLoading: false,
};

export const catalogReducer = (state = initCatalog, action: any) => {
  if (action.type === "SET_CATALOG") {
    return {
      ...state,
      catalogs: action.value,
    };
  }
  if (action.type === "SET_CATALOG_CATEGORY") {
    return {
      ...state,
      catalogCategories: [{ category: "all" }, ...action.value],
    };
  }
  if (action.type === "SET_CATALOG_DETAIL") {
    return {
      ...state,
      catalogDetail: action.value,
    };
  }
  if (action.type === "SET_CATALOG_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_CATALOG_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_CATALOG") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_CATALOG_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_CATALOG_DETAIL_LOADING") {
    return {
      ...state,
      isCatalogDetailLoading: action.value,
    };
  }
  return state;
};
